<template>
  <q-tab-pane name="invoices" class="scroll-y" :class="{ 'no-padding': invoices.length !== 0 }">
    <div class="row justify-between border-bottom customer-card__stats" v-if="invoices.length">
      <div class="col row justify-center">
        <div>
          <h4 class="text-weight-thin no-margin">{{ formatMoney(totalRevenue, totalRevenueCurrency, 0, 0) }}</h4>
          <span class="text-faded text-weight-light">{{ $t('statistics_revenue') }}</span>
        </div>
      </div>

      <div class="col row justify-center">
        <div>
          <h4 class="text-weight-thin no-margin">{{ totalInvoiceCount }}</h4>
          <span class="text-faded text-weight-light">{{ $tc('invoice', totalInvoiceCount) }}</span>
        </div>
      </div>
    </div>

    <!-- Wrapping div to fix safari sticky position -->
    <div>
      <div v-if="!isSupplier && invoices.length" class="row sticky-top bg-white q-px-md q-py-sm border-bottom customer-card__toolbar" v-is-user>
        <q-btn flat icon="add" :label="$tc('invoice', 1)" @click="handleCreateInvoice"></q-btn>
      </div>

      <div class="text-select">
        <invoice-table
          v-if="invoices.length"
          :invoices="invoices"
          :mapFunctionOverride="mapFunction"
          :columnsOverride="columns"
          class="no-shadow"
        />
        <template v-else>
          <div class="row justify-center items-center col-grow q-pt-lg">
            <div class="text-center">
              <img src="~assets/emptystates/invoices_empty.svg" height="100px" />

              <h6 class="q-my-md text-faded">{{ $t('invoices_empty') }}</h6>

              <q-btn v-if="!isSupplier" @click="handleCreateInvoice" color="primary" class="q-mt-lg" outline v-is-user>
                {{ $t('create_invoice') }}
              </q-btn>
            </div>
          </div>
        </template>
      </div>
    </div>
  </q-tab-pane>
</template>

<script>
  import { columns, mapFunction } from 'components/Invoices/Table/customerInvoiceTable'
  import InvoiceTable from 'components/Invoices/Table/StaticInvoiceTable.vue'
  import { businessPartnerTypes } from 'src/utils/businessPartnerTypes'
  import { formatMoney } from 'src/utils/format'

  export default {
    props: {
      customer: {
        type: Object,
        required: true
      }
    },

    computed: {
      invoices () {
        return this.customer.invoices ? this.customer.invoices.data : []
      },

      totalRevenue () {
        return this.customer.statistics.data.revenue.value
      },

      totalRevenueCurrency () {
        return this.customer.statistics.data.revenue.currency
      },

      totalInvoiceCount () {
        return this.customer.statistics.data.invoice_count
      },

      mapFunction () {
        return mapFunction
      },

      columns () {
        return columns
      },

      isSupplier () {
        return this.customer.business_partner_type === businessPartnerTypes.SUPPLIER
      }
    },

    methods: {
      formatMoney,

      handleCreateInvoice () {
        this.$router.push({
          name: 'create-invoice',
          params: { teamId: this.customer.team_id },
          query: { customer: this.customer.id }
        })
      }
    },

    components: {
      InvoiceTable
    }
  }
</script>
